import React from 'react'
import './whatsapp.css';

export const WhatsappButtonScreen = () => {
    return (
        <>
            <a className='btn-wsp' href="https://wa.link/72t5ik" target="_blank" style={{textDecoration: 'none' }}>
                <i className="fab fa-whatsapp fa-1x"  ></i>

            </a>
        </>
    )
}
